import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import {
  getProfileOwnerUser,
  getProfileOwnerIsOfferingSubscriptions,
} from '../../../selectors/users';
import { Props } from './TierBanner';

type StateProps = Pick<Props, 'show' | 'profileOwnerUser'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const show = getProfileOwnerIsOfferingSubscriptions(state);
  const profileOwnerUser = getProfileOwnerUser(state);
  return {
    show,
    profileOwnerUser,
  };
};

export default connect(mapStateToProps);
